import React from 'react';
import './styles.css';

const src = new URL('../../assets/loading_circle.svg', import.meta.url).toString();

export default function LoadingCircle({ isStatic, style }: { isStatic?: boolean, style?: React.CSSProperties }) {
  return <img src={src} alt="loading indicator" className={isStatic ? '' : "spin"} style={style} />;
}
